import { StyleConfig } from '@chakra-ui/react';

const text: StyleConfig = {
  baseStyle: { m: 0 },
};

export default text;
